export default "__VITE_PUBLIC_ASSET__f5926a6c__"